module.exports = __webpack_public_path__ + "img/trial1-3.a69b93fb.png";